__turbopack_context__.v({
  "cta": "hotline-modal-module__VXumiW__cta",
});
